export default {
  ID() {
    return '_' + Math.random().toString(36).substr(2, 9);
  },

  focusElement(id, force) {
    if (force || window.innerWidth > 767) {
      const el = document.getElementById(id);

      if (el) {
        setTimeout(function () {
          el.focus();
        }, 100);
      }
    }
  },

  selectElement(id) {
    const el = document.getElementById(id);
    if (el) {
      setTimeout(function () {
        document.getElementById(id).select();
      }, 100);
    }
  },

  scrollView(id) {
    const el = document.getElementById(id);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView(true);
      }, 0)
    }
  },

  isMobile() {
    return (window.screen.width <= 767);
  }
};
